import { memo, type FC } from 'react'
import { Box, styled } from '@mui/material'
import { zIndexGuidedTour } from './zIndex.js'
import { guidedTourClasses } from './classes.js'

export type FocusBackdropDimensions = {
  top: number
  left: number
  height: number
  width: number
}

const Layover = styled(Box)({
  position: 'absolute',
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  cursor: 'default',
  zIndex: zIndexGuidedTour.layover,
})

type FocusBackdropProps = {
  dimensions: FocusBackdropDimensions
}

// eslint-disable-next-line react/prop-types
export const FocusBackdrop: FC<FocusBackdropProps> = memo(({ dimensions }) => (
  <Layover className={guidedTourClasses.backdrop}>
    <Box
      className={guidedTourClasses.focus}
      sx={{
        position: 'absolute',
        boxShadow: (theme) => `0 0 0 99999px ${theme.palette.components.backdrop.fill}`,
        ...dimensions,
      }}
    />
  </Layover>
))
